import * as React from 'react';
import { Form, Formik } from 'formik';
import { DatePicker as SitDatePicker } from 'Src/components/DatePicker/DatePicker';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { ReportActions, ReportDescription, ReportSection } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Clubs.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; }
export function DateClubsReportForm({ onCloseClick, onSubmit }: Props) {
  return <Formik initialValues={{ dateFrom: new Date() }} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.DATE_CLUBS)}>
    {({ values, setFieldValue }) => <Form className="eReportForm compactClubReportForm"><div className="eReportForm__scroll">
        <ReportDescription>A list of every club session scheduled on the selected date, including its time, eligible students, location and staff.</ReportDescription>
      <ReportSection number={1} title="Report date" hint="Choose the date included in the report." required>
        <div className="eReportDateRange">
          <SitDatePicker mode="date" value={values.dateFrom} onChange={value => value instanceof Date && setFieldValue('dateFrom', value)} format="DD-MM-YYYY" placeholder="Select date" className="eReportDateRange__picker" />
        </div>
      </ReportSection>
    </div><ReportActions onCancel={onCloseClick} /></Form>}
  </Formik>;
}
